export function convertSeconds(totalSeconds: number) {
    // Calcular los minutos
    const minutes = Math.floor(totalSeconds / 60);

    // Calcular los segundos restantes
    const seconds = totalSeconds % 60;

    // Formatear los segundos con dos dígitos
    const formattedSeconds = seconds < 10 ? '0' + seconds : seconds;

    // Retornar el formato "minutos:segundos"
    return `${minutes}:${formattedSeconds}`;
}
